import { IAPIAction } from "us.collection/interfaces";
import { SelectedCreditor } from "us.collection.creditor/constants/Actions/SelectedCreditors";

export const selectedCreditors: Readonly<IAPIAction> = {
  creditorAuthorizedInformation: {
    save: (data) => ({
      type: SelectedCreditor.ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SelectedCreditor.ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SelectedCreditor.ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },
};
